import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../../app.service';
import { AddCrackObsPointDialogComponent } from '../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { ChangeCrackStatusComponent } from '../../equipment-details/components/change-crack-status/change-crack-status.component';
import { CrackCommentsDialogComponent } from '../../equipment-details/components/crack-comments-dialog/crack-comments-dialog.component';
import { ObspointActionHistroyComponent } from '../../equipment-details/components/obspoint-action-histroy/obspoint-action-histroy.component';
import { ComponentObservationPointDetails, SchematicAndObservationPointDetails, SchematicDetails } from '../../equipment-details/equipment-details.model';
import { ObservationPointVM } from '../../favourite-dialog/favourite-dialog-modal';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { SchemanticOpPopupEditComponent } from '../../schemantic-op-popup-edit/schemantic-op-popup-edit.component';
import { ComponentVM, ObservationPointVMEdit } from '../../setup-implement/setup-implement.model';
import { SetupImplementService } from '../../setup-implement/setup-implement.service';

@Component({
  selector: 'app-asset-detail-history-dfi',
  templateUrl: './asset-detail-history-dfi.component.html',
  styleUrls: ['./asset-detail-history-dfi.component.scss'],
  animations: [
    trigger(
        'fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 0 }),
                animate('0ms', style({ opacity: 0 }))
            ])
        ]
    )]
})
export class AssetDetailHistoryDfiComponent implements OnInit {

  @Input() SchematicAndObservationPoints: SchematicAndObservationPointDetails = new SchematicAndObservationPointDetails();
  @Input() cusID: number;
  @Input() SMU: number;
  @Input() isCrack: number;
  @Input() ImplementId: number;


  @Input() equipmentId: number;
  @Output() updateObs: EventEmitter<boolean> = new EventEmitter();


  oldGETUri: string;
  ObservationPointDetails: ComponentObservationPointDetails[];
  schematicDetails: SchematicDetails; 
  
  schematicImage: string;
  //edit observation points

  draggableSchematicTitle: string = "Schematic";
  selectedSchematicEdit: ObservationPointVMEdit
  currentStep: number = 0;
  mouseoverOPId: number = 0;
  headerAction:ComponentObservationPointDetails;
  constructor(private _sanitizer: DomSanitizer,private _dialog: MatDialog,
      private _appService: AppService,  private _moduleService: ImplementDetailsService,
      private _implementService: SetupImplementService,
      ) { }


      ngOnInit() {
        this.ObservationPointDetails = this.SchematicAndObservationPoints.ObservationPoints;
        this.schematicDetails = this.SchematicAndObservationPoints.Schematic;
        this.headerAction = this.ObservationPointDetails.length>0?this.ObservationPointDetails[0]:null;

        //console.log(" this.schematicDetails", this.schematicDetails)
        console.log(" this.iscrack", this.isCrack,this.ImplementId)
        if(this.ImplementId>0 && this.ImplementId!=null){
            this.loadComponentList();
        }
    }

    sanitize(image: string) {

        //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }

    getCrackStatus(IsFixed: boolean) {
        if (IsFixed ==true) {
            return " WornPctCell evalColorA";
        }
        else  {
            return " WornPctCell evalColorX";
        }
        
    }

    getEvalClass(wornPct: number) {
        if (wornPct <= 30) {
            return " WornPctCell evalColorA";
        }
        else if ((wornPct > 30) && (wornPct <= 60)) {
            return " WornPctCell evalColorB";
        }
        else if ((wornPct > 60) && (wornPct <= 80)) {
            return " WornPctCell evalColorC";
        }
        else if (wornPct > 80) {
            return "WornPctCell evalColorX";
        }

        return " WornPctCell noEval";
    }

    getEvalClass2(evalCode: string) {
        if (evalCode == "A") {
            return " WornPctCell evalColorA";
        }
        else if (evalCode == "B") {
            return " WornPctCell evalColorB";
        }
        else if (evalCode == "C") {
            return " WornPctCell evalColorC";
        }
        else if (evalCode == "X") {
            return "WornPctCell evalColorX";
        }

        return " WornPctCell noEval";
    }
    
    // gotoObservationListPage() {
    //     this._appService.getApplicationConfigValue("oldGETUri").subscribe(result => {
    //         this.oldGETUri = result;
    //         if (this.cusID <= 0) {
    //             window.open(this.oldGETUri + 'GET/SelectObservationListCustomer.aspx', '');
    //         }
    //         else {
    //             window.open(this.oldGETUri + 'GET/ManageObservationLists.aspx?cu=' + this.cusID, '');
    //         }
    //     });
    // }

    gotoModifyImplementPage() {
        window.open('setup/existing-implement');
    }

    OpenCrackFixedDialog(OBPoint:ComponentObservationPointDetails){
        //console.log("open crack statu" , OBPoint)

    if(OBPoint.Type=="Crack"){
        const inspectionPlannerDialog = this._dialog.open(ChangeCrackStatusComponent, {
            panelClass: 'removeModalOverflow',
            disableClose: true,
            data: {
                obsId:OBPoint.Id,
                compName:OBPoint.ComponentName,
                ObsName:OBPoint.Name,
                IsCrackFixed:OBPoint.IsCrackFixed,
                curretSmu:this.SMU,
                Crackcomment:OBPoint.Crackcomment,
                implementId:this.ImplementId,
                equipmentId:this.equipmentId
            },
            minWidth: 300
        });

        inspectionPlannerDialog.afterClosed().subscribe(result => {

            if (result==true) {
                this.updateObs.emit(true);
                //this.loadEquipmentDetails();
            }
        });
    }
        
    }

    OpenNormalObsHistroyDialog(OBPoint: ComponentObservationPointDetails) {
        //console.log("open crack statu", OBPoint)
    
        if (OBPoint.ObPointTypeId !== 2) {
          //console.log("open crack statu__", OBPoint)
          let inspectionPlannerDialog = this._dialog.open(ObspointActionHistroyComponent, {
            panelClass: 'removeModalOverflow',
            disableClose: true,
            data: {
              obId: OBPoint.Id,
              CompName: OBPoint.ComponentName,
              ObsName: OBPoint.Name,
              componentId: OBPoint.ComponentId,
              isCrack:false,
            },
    
          });
    
          inspectionPlannerDialog.afterClosed().subscribe(result => {
    
            if (result == true) {
              this.updateObs.emit(true);
              //this.loadEquipmentDetails();
            }
          });
        }
        if (OBPoint.ObPointTypeId === 2) {
          let openRemoveImplementModalRef = this._dialog.open(ObspointActionHistroyComponent, {
            panelClass: 'removeModalOverflow',
            disableClose: true,
            data: {
              obId: OBPoint.Id,
              CompName: OBPoint.ComponentName,
              ObsName: OBPoint.Name,
              componentId: OBPoint.ComponentId,
              isCrack:true,
            }
          });
          openRemoveImplementModalRef.afterClosed().subscribe((result) => {
    
            if (result == true) {
              this.updateObs.emit(true);
            }
          });
        }
    
      }
      componentList: ComponentVM[];
      loadComponentList() {
        //this._moduleService.returnComponentsForGET(this.implementID.toString()).subscribe(res => {

        this._implementService.ReturnGETComponents(this.ImplementId).subscribe(result => {
            this.componentList = result
        }, error => { console.log(error); });
    }
      
      // usage example:
      
    obsDetails_: ObservationPointVM[];
    openSchematicWindow(SchematicImage:SchematicDetails){
        console.log("this.componentList", this.componentList)
        let arr_ = [];
        let comarr=[]
        let comarrfiltered=[]
        this.ObservationPointDetails.map(x=>{
            var neModl =  new ObservationPointVM();
            neModl.ObservationPointId=x.Id;
            neModl.ObservationPointPosX=x.PositionX;
            neModl.ObservationPointPosY=x.PositionY;
            neModl.EndObservationPointPosX=x.EndPositionX;
            neModl.EndObservationPointPosY=x.EndPositionY;
            neModl.isCrackFixed=x.IsCrackFixed;
            neModl.ObservationPointName=x.Name;
            neModl.pointLedgend=3
            arr_.push(neModl)
        })

        //TT-5468
        // this.ObservationPointDetails.map(x=>{
        //     var comModel= new ComponentsVM();
        //     comModel.ComponentId=x.ComponentId;
        //     comModel.ComponentName=x.ComponentName;
        //     comarr.push(comModel)

        // })
      
        // var newarr = [comarr[0]];
        // for (var i=1; i<comarr.length; i++) {
        //    if (comarr[i].ComponentId!=comarr[i-1].ComponentId) newarr.push(comarr[i]);
        // }            
        const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
         
          data: {
            obsDetails:arr_,
            schematic:SchematicImage.Data,
            componentList:this.componentList,
           schematicId:SchematicImage.Id,
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {         
          if(details>0){
            this.updateObs.emit(true);
            // this._moduleService.GetSchematicsForImplement(this.implementId).subscribe(details => {
            //     this.ImplementForEquipmentDetails = details;
            //     this.loading = false
           
          }else{
            
          }
        });
       
      }

      openSchematicWindowforEdit( obserationID, imgOrSchematic) {
        
        if (imgOrSchematic == 1) {
            this.draggableSchematicTitle = "Implement Image";
        } else if (imgOrSchematic == 2) {
            this.draggableSchematicTitle = "Schematic";
        }
        this._implementService.GetSchematicDataForEditObsevationPoint(obserationID).subscribe(r => {
            //console.log('r', r)
          
          
            if(r.length>0)
            {
                this.selectedSchematicEdit=r[0]
                const addSectionDialog = this._dialog.open(SchemanticOpPopupEditComponent, {
         
                    data: {
                      schematic: this.selectedSchematicEdit,
                      currentStep:2,
                      mouseoverOPId:r[0].Id,
                      title:this.draggableSchematicTitle
                     
                    }
                  });
                  addSectionDialog.afterClosed().subscribe(details => {         
               
                  });
          
            }
           
        });

        
    }


    
    OpenCrackCommentDialog(OBPoint:ComponentObservationPointDetails){
      
    if(OBPoint.Type=="Crack"){
        const inspectionPlannerDialog = this._dialog.open(CrackCommentsDialogComponent, {
            panelClass: 'removeModalOverflow',
            disableClose: true,
            data: {
                // obsId:OBPoint.Id,
                // compName:OBPoint.ComponentName,
                // ObsName:OBPoint.Name,
                // IsCrackFixed:OBPoint.IsCrackFixed,
                // curretSmu:this.SMU,
                Crackcomment:OBPoint.Crackcomment
            },
           // minWidth: 300
        });

        inspectionPlannerDialog.afterClosed().subscribe(result => {

            // if (result==true) {
            //     this.updateObs.emit(true);
            //     //this.loadEquipmentDetails();
            // }
        });
    }
        
    }


    

}
